import { axiosInstance } from '../axios';

interface UpdateUserVariables {
  id: string;
  name: string;
  email: string;
  phone?: string;
  celphone?: string;
}

export function updateUser(variables: UpdateUserVariables) {
  return axiosInstance.post(
    `/user/${variables.id}/update`,
    variables
  );
}

export function updateUserPassword(variables: {
  id: string;
  password: string;
  confirmPassword: string;
}) {
  return axiosInstance.post(`/user/${variables.id}/change-password`, {
    password: variables.password,
    confirmPassword: variables.confirmPassword,
  });
}
